// GlobalLoading.vue
<template>
  <el-dialog :visible.sync="hasSideEffectLoading" width="30%" :close-on-click-modal="false"
    :before-close="handleDialogClose">
    <div class="loading-content">
      <el-spinner />
      <p>Loading, please wait...</p>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SideEffectLoading',
  computed: {
    ...mapGetters(['hasSideEffectLoading'])
  },
  methods: {
    handleDialogClose(done) {
      done();
    },
  }
};
</script>

<style>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.5); */
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  text-align: center;
}

.loading-content .el-spinner {
  margin-bottom: 16px;
}

.el-dialog__body {
  font-size: 14px;
}
</style>